<template>
  <div>
    <a-spin :spinning="isLoading">
      <div class="flex">
        <h2 class="text-2xl">Edit Tiktok</h2>
      </div>
      <div class="grid grid-cols-6 gap-8">
        <div class="col-span-4">
          <Form v-model="form" v-model:mediaType="mediaType" />
        </div>
        <div class="col-span-2">
          <Tiktok :data="form" />
        </div>
        <div class="col-span-5 flex justify-evenly pb-4">
          <button
            class="bg-red-500 hover:bg-red-700 text-white font-bold px-4 rounded flex items-center"
            @click="modalIsVisible = true"
          >
            Delete
          </button>
          <router-link to="/tiktoks">
            <a-button>Cancel</a-button>
          </router-link>
          <a-button type="primary" @click="onSubmit">
            Save
          </a-button>
        </div>
      </div>
    </a-spin>
    <Modal
      v-model:isVisible="modalIsVisible"
      v-model:id="this.$route.params.id"
    />
  </div>
</template>

<script>
import Form from "@/components/Form/tiktok-form.vue";
import Tiktok from "@/components/Tiktok";
import Modal from "@/components/Modals/DeleteTiktok";
import { ref, computed } from "vue";
import { useStore } from "vuex";

export default {
  components: { Form, Tiktok, Modal },
  async mounted() {
    const data = await this.$store.dispatch(
      "GET_TIKTOK_BY_ID",
      this.$route.params.id
    );
    this.form = { ...this.form, ...data.data };
  },
  setup() {
    const store = useStore();

    const modalIsVisible = ref(false);

    const modal = computed(() => store.state.modalIsVisible);

    return { modalIsVisible, modal };
  },
  data() {
    return {
      isLoading: false,
      subindustries: null,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      mediaType: "link",
      form: {
        username: null,
        post_id: null,
        description: null,
        views: null,
        likes: null,
        shares: null,
        comments: null,
        industry: null,
        duration: null,
        music_title: null,
        download_link: null,
        tiktok_link: null,
        created_time: null,
        is_ad: null,
        new: null,
        is_free: null,
      },
    };
  },
  methods: {
    async onSubmit() {
      const { success } = await this.updateTiktok();
      if (success) {
        this.$router.push("/tiktoks");
      }
    },
    async updateTiktok() {
      this.isLoading = true;
      const tiktok = await this.$store.dispatch("UPDATE_TIKTOK", this.form);
      if (this.mediaType == "file") {
        const media = await this.uploadFile(tiktok.data.id);
        this.isLoading = false;
        return media;
      }
      this.isLoading = false;
      return tiktok;
    },
    async uploadFile(id) {
      let formdata = new FormData();
      formdata.append("id", id);
      formdata.append("folder", "tiktok_media");
      formdata.append("file", this.form.download_link);
      return await this.$store.dispatch("UPLOAD_TIKTOK_MEDIA", formdata);
    },
  },
};
</script>

<style scoped>
.advertisements__new__actions button ~ button,
.advertisements__new__actions a ~ a,
.advertisements__new__actions a ~ button,
.advertisements__new__actions button ~ a {
  margin-left: 10px;
}
.custom_select--group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}
</style>
